//коды стран в гугл поиске по которым будет искать результаты и сколько выдавать в поиске
export const countryArr = [
    {
        country: 'countryUS',//соединенные штаты
        num: 20
    },
    {
        country: 'countryGB',//великобритания
        num: 20
    },
    {
        country: 'countryCA',//канада
        num: 20
    },
    {
        country: 'countryAU',//австралия
        num: 20
    },
    {
        country: 'countrySG',//сингапур
        num: 20
    },
    {
        country: 'countryZA',//юар
        num: 20
    },
    {
        country: 'countryIE',//ирландия
        num: 20
    },
    {
        country: 'countryNZ',//новая зеландия
        num: 20
    },
    {
        country: 'countryDE',//германия
        num: 10
    },
    {
        country: 'countryFR',//франция
        num: 10
    },
    {
        country: 'countryPH',//филиппины
        num: 10
    },
    {
        country: 'countryEG',//египет
        num: 10
    },
    {
        country: 'countryPL',//польша
        num: 10
    },
    {
        country: 'countryBE',//бельгия
        num: 10
    },
    {
        country: 'countryAT',//австрия
        num: 10
    },
    {
        country: 'countryES',//испания
        num: 10
    },
    {
        country: 'countryPT',//португалия
        num: 10
    },
    {
        country: 'countrySE',//швеция
        num: 10
    },
    {
        country: 'countryCH',//швейцария
        num: 10
    },
    {
        country: 'countryIT',//италия
        num: 10
    },
    {
        country: 'countryFI',//финляндия
        num: 10
    },
    {
        country: 'countryBR',//бразилия
        num: 10
    },
    {
        country: 'countryAR',//аргентина
        num: 10
    },
]

//лист сайтов исключений, c которых не нужно парсить email
export const excludeList = ['microsoft', 'wikipedia', 'pinterest', 'linkedin', 'facebook', 'instagram', 'reddit',]